<template>
  <v-app-bar elevation="0" height="auto" class="app-header-bar">
    <v-container fluid class="pa-0" v-if="isDesktopOrTabletLandscape">
      <v-row no-gutters class="app-bar-store-name">
        <v-col cols="auto">
          {{ currentStore }}
        </v-col>
        <v-spacer />
        <v-col cols="auto"><StoreSelector /></v-col>
      </v-row>
    </v-container>
    <v-container fluid class="pa-0" v-else-if="isMobileOrTabletPortrait">
      <v-expansion-panels
        v-model="painelControl"
        variant="accordion"
        elevation="0"
        bg-color="transparent"
        color="transparent"
      >
        <v-expansion-panel>
          <template #title>
            <v-row no-gutters class="app-bar-store-name">
              {{ currentStore }}
            </v-row>
          </template>
          <template #text>
            <StoreSelector ref="StoreSelector" />
          </template>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-app-bar>
</template>
<script>
import StoreSelector from "@/components/utils/StoreSelector.vue";
export default {
  name: "DefaultAppBar",
  components: {
    StoreSelector
  },
  data: () => ({
    painelControl: 0
  }),
  mounted() {
    setTimeout(() => {
      this.painelControl = null;
    }, 100);
  },
  computed: {
    isDesktopOrTabletLandscape() {
      return (
        this.$store.getters.isDesktop || this.$store.getters.isTabletLandscape
      );
    },
    isMobileOrTabletPortrait() {
      return (
        this.$store.getters.isMobile || this.$store.getters.isTabletPortrait
      );
    },
    currentStore() {
      if (!this.$store.getters.getSelectedStore) return null;
      return this.$store.getters.getSelectedStore.name;
    }
  },
  watch: {
    painelControl(value) {
      if (value === 0) {
        setTimeout(() => {
          this.$refs.StoreSelector.expandMenu(true);
        }, 200);
      }
    }
  }
};
</script>
<style src="@/styles/global.css"></style>
